<template>
  <v-menu
    ref="menu"
    v-model="timeMenu"
    :close-on-content-click="false"
    style="z-index: 10000"
    transition="scale-transition"
    offset-y
    min-width="auto"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="input[cellKey]"
        :label="getTitle(cell)"
        prepend-icon="mdi-clock-outline"
        @click:prepend="on.click"
        @click:clear="input[cellKey] = null"
        readonly
        v-bind="attrs"
        v-on="on"
        clearable
      ></v-text-field>
    </template>
    <v-time-picker format="24hr" :value="input[cellKey]" @input="dateMenu = false" @change="(v) => onDateSelect(v, cellKey)" />
  </v-menu>
</template>

<script>
import dateTimeMixin from '../../../mixins/dateTimeMixin';
import { getTitle } from './wb-common';
import dateUtils from '@/common/dateUtils';

export default {
  props: {
    cell: { type: Object, required: true },
    namespace: { type: String, required: true },
    mIndex: { type: String, default: '' },
  },
  mixins: [dateTimeMixin],
  data() {
    return {
      timeMenu: false,
      getTitle,
    };
  },
  created() {
    if (this.cell.cellName === 'UDTimeCell') {
      //UDDateCell should initially show the current date (and be reactive)
      this.$set(this.input, this.cellKey, dateUtils.formatTimeHHmm(new Date()));
    }
  },
  computed: {
    input() {
      return this.$store.state[this.namespace].formInput;
    },
    cellKey() {
      return this.cell.key + this.mIndex;
    },
  },
  methods: {
    onDateSelect(v, key) {
      this.$set(this.input, key, v);
    },
  },
};
</script>
